import { Grid, Paper, Typography, useTheme } from "@material-ui/core";
import { FieldArray, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import styles from "./FinalTestForm.module.scss";
import Input from "../../../components/Input";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../../../components/Select";
import { formatOptions } from "../../../utils/Helpers";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveIcon from "@material-ui/icons/Remove";
import {
  getBooksRequest,
  getSingleBookRequest
} from "../../../store/Books/actions";
import { useParams } from "react-router-dom";
import {
  ADD_EDIT_TEST_SCHEMA,
  getInitialValuesAdd,
  getInitialValuesEdit
} from "./validation";
import MaterialPreview from "../../../components/MaterialPreview";
// import Upload from "./finalTestImageUploading";
import Button from "../../../components/Button";
import {
  editSingleFinalTestRequest,
  getAllFinalTestsRequest,
  getSingleFinalTestsRequest,
  setNewFinalTestRequest
} from "../../../store/FinalTests/actions";

import AnswerDisplay from "./AnswerDisplay";
import AnswerAddOrEdit from "./AnswerAddOrEdit";

import { showHideLoader } from "../../../store/Loader/actions";
import { showHideSnackbar } from "../../../store/Snackbar/actions";
import Upload from "../../../components/Upload";
import { uploadToS3 } from "../../../utils/S3";

function FinalTestFormAEV() {
  // const [setDestroy] = useState(false);
  const [isDicom, setIsDicom] = useState(false);
  const formRef = useRef();
  const uploadQuestionRef = useRef();
  const uploadJustificationRef = useRef();
  let params = useParams();
  const dispatch = useDispatch();
  const { locale, messages } = useIntl();

  let mode = params?.mode;
  const singleFinalTest = useSelector(
    (state) => state.finalTestsReducer.singleFinalTest
  );

  useEffect(() => {
    if (params?.id) {
      let id = parseInt(params.id);
      dispatch(getSingleFinalTestsRequest(id));
    }
  }, []);
  useEffect(() => {
    setIsDicom(false);
    dispatch(getBooksRequest({ lookup: true }));
  }, []);
  useEffect(() => {
    dispatch(getAllFinalTestsRequest());
  }, []);
  const finalTestList = useSelector(
    (state) => state.finalTestsReducer.list
  );

  const books = useSelector((state) => state.books.list);
  const existingBook = books.find(
    (book) => book.id === singleFinalTest?.book_id
  );
  const newOptions = books?.filter((book) => {
    return !finalTestList?.filter(
      (finalTest) => finalTest.book_id === book.id
    ).length;
  });

  const theme = useTheme();

  const {
    finalTest: {
      addFinalTest,
      editFinalTest,
      book,
      totalScore,
      notes,
      noteHint,
      questionTitle,
      upload,
      uploadImageLabel,
      explanation,
      questionPoints,
      viewFinalTest
    },
    buttons: { submit }
  } = messages;
  const AddRemoveNewQuestion = (push) => {
    return (
      <>
        <div className="mx-2 mb-3">
          <AddCircleIcon
            className="cursor-pointer"
            onClick={() =>
              push({
                question: "",
                points: null,
                answer_choices: [
                  {
                    currentTab: "text",
                    answer: "",
                    image_url: "",
                    correct: false,
                    justification: ""
                  },
                  {
                    currentTab: "text",
                    answer: "",
                    image_url: "",
                    correct: false,
                    justification: ""
                  }
                ]
              })
            }
          />
        </div>
      </>
    );
  };

  const RemoveQuestion = (
    question,
    remove,
    questionIndex,
    replace
    // mode,
    // setDestroy
  ) => {
    return () => {
      if (!question.id) {
        remove(questionIndex);
        return;
      }
      replace(questionIndex, {
        ...question,
        _destroy: true
      });
      // if (mode === "Edit") setDestroy(true);
    };
  };
  const updatedQuestions = async (values) => {
    return await Promise.all(
      values.details.questions.map(async (question) => {
        const updatedQuestion = { ...question };

        // Handle question image
        try {
          if (updatedQuestion.image_url?.file instanceof File) {
            const { link } = await uploadToS3(
              "private",
              updatedQuestion.image_url.file,
              updatedQuestion.image_url.file.name
            );
            updatedQuestion.image_url = link;
          }
        } catch (err) {
          console.error("Failed to upload question image", err);
          updatedQuestion.image_url = null; // or keep the file
        }

        // Handle justification image
        try {
          if (
            updatedQuestion.justification_image_url?.file instanceof
            File
          ) {
            const { link } = await uploadToS3(
              "private",
              updatedQuestion.justification_image_url.file,
              updatedQuestion.justification_image_url.file.name
            );
            updatedQuestion.justification_image_url = link;
          }
        } catch (err) {
          console.error("Failed to upload justification image", err);
          updatedQuestion.justification_image_url = null;
        }

        // Handle answers
        updatedQuestion.answer_choices = await Promise.all(
          question.answer_choices.map(async (answer) => {
            const updatedAnswer = { ...answer };

            try {
              if (
                updatedAnswer.currentTab !== "text" &&
                updatedAnswer.image_url?.file instanceof File
              ) {
                const { link } = await uploadToS3(
                  "private",
                  updatedAnswer.image_url.file,
                  updatedAnswer.image_url.file.name
                );
                updatedAnswer.image_url = link;
              }
            } catch (err) {
              console.error("Failed to upload answer image", err);
              updatedAnswer.image_url = null;
            }

            return updatedAnswer;
          })
        );

        return updatedQuestion;
      })
    );
  };
  const handleSubmit = async (values) => {
    dispatch(showHideLoader(true));

    if (mode === "Add") {
      values.details.questions = await updatedQuestions(values);
      // console.log("editValues", editValues);

      dispatch(setNewFinalTestRequest(values));
    } else {
      values.details.questions = await updatedQuestions(values);

      dispatch(
        editSingleFinalTestRequest({
          final_test: values,
          id: singleFinalTest.id
        })
      );
    }
  };

  const DoesQuestionHasAJustificationPhoto = (
    values,
    questionIndex
  ) =>
    mode !== "View"
      ? true
      : !!values?.details?.questions[questionIndex]
          .justification_image_url;

  async function handleUploadSingleImage(e, qIndex, type) {
    let file = e?.target?.files[0];
    if (file) {
      if (file?.type?.includes("image")) {
        let url = URL.createObjectURL(file);
        let objFile = { file, url };
        console.log(
          " formRef.current",
          formRef.current.setFieldValue
        );

        if (type == "question") {
          console.log("objFile", objFile);
          formRef.current.setFieldValue(
            `details.questions[${qIndex}].image_url`,
            objFile
          );
          if (uploadQuestionRef.current)
            uploadQuestionRef.current.value = null;
        } else if (type == "justification") {
          formRef.current.setFieldValue(
            `details.questions[${qIndex}].justification_image_url`,
            objFile
          );
          if (uploadJustificationRef.current)
            uploadJustificationRef.current.value = null;
        }
        // Clear input value
        e.target.value = null;
      } else {
        dispatch(
          showHideSnackbar({
            type: "error",
            isOpen: true,
            message: "Please select image"
          })
        );
      }
    }
  }
  return (
    <>
      <div className="mb-4">
        <Typography variant="h4" component="h1">
          {mode === "Edit" ||
          JSON.parse(sessionStorage.getItem("bookSelected"))?.id
            ? editFinalTest
            : mode === "View"
            ? viewFinalTest
            : addFinalTest}
        </Typography>
      </div>
      <Formik
        innerRef={formRef}
        initialValues={
          mode === "Add"
            ? getInitialValuesAdd()
            : getInitialValuesEdit(singleFinalTest)
        }
        onSubmit={handleSubmit}
        validationSchema={
          mode === "View" ? null : ADD_EDIT_TEST_SCHEMA(locale)
        }
        enableReinitialize
      >
        {({ setFieldValue, values }) => {
          return (
            <Form>
              <fieldset
                disabled={mode === "View" ? true : false}
                className={
                  mode === "View" ? styles.disableFormEdit : null
                }
              >
                <Grid spacing={5}>
                  <Grid item className="pb-0">
                    <div className={styles.selectTitle}>
                      {mode !== "Add" && (
                        <label className={styles.label}>
                          {book} <span>*</span>{" "}
                        </label>
                      )}
                      <CustomSelect
                        options={[...newOptions, existingBook]
                          .filter((book) => book && book.id) // Filter out undefined/null or objects without id
                          .map((book) =>
                            formatOptions(book, "id", "title")
                          )}
                        placeholder={book}
                        name="book_id"
                        bgColor={theme.palette.primary.light}
                        isRequired={true}
                        isMenuRelative={true}
                        isSearchable={true}
                        onChange={(e) => {
                          console.log("ee", e);
                          setFieldValue("book_id", e.id);
                        }}
                        handleSelectChange={() => {
                          if (values.book_id)
                            dispatch(
                              getSingleBookRequest(values.book_id)
                            );
                        }}
                        containerClass="mb-4"
                      />
                    </div>
                    <Input
                      style={{ width: "100%" }}
                      name={`total_score`}
                      label={totalScore}
                      isRequired={true}
                      type="number"
                      isNumber={true}
                      step="0.1"
                    />

                    <div>
                      <p>{noteHint}</p>
                      <Input
                        inputShape="textarea"
                        showCounter={true}
                        charLimit={800}
                        name="note"
                        label={notes}
                        isRequired={false}
                        type="text"
                      />
                    </div>
                    <div className="mb-4">
                      <FieldArray name="details.questions">
                        {({ push, replace, remove }) => {
                          return !values?.details.questions?.length
                            ? null
                            : values?.details.questions?.map(
                                (question, questionIndex) => {
                                  return (
                                    !question._destroy && (
                                      <div className="d-flex">
                                        <Paper
                                          style={{ padding: "2rem" }}
                                          className="row align-items-center justify-content-center flex-fill mb-4"
                                        >
                                          <div className="d-flex align-items-center justify-content-between">
                                            <div
                                              style={{
                                                width: "100%"
                                              }}
                                            >
                                              <Input
                                                name={`details.questions[${questionIndex}].question`}
                                                label={questionTitle}
                                                isRequired={
                                                  mode === "View"
                                                    ? false
                                                    : true
                                                }
                                              />
                                            </div>
                                            {mode !== "View" && (
                                              <a
                                                data-bs-toggle="collapse"
                                                href={`#collapseExample${questionIndex}`}
                                                role="button"
                                                aria-expanded="false"
                                                aria-controls="collapseExample"
                                                style={{
                                                  width: "100px",
                                                  marginLeft: "10px"
                                                }}
                                                className="mb-4"
                                              >
                                                {uploadImageLabel}
                                              </a>
                                            )}
                                          </div>

                                          <div
                                            className={
                                              values?.details
                                                .questions?.[
                                                questionIndex
                                              ]?.image_url
                                                ? "collapse show p-2 mb-2"
                                                : "collapse p-2 mb-2"
                                            }
                                            id={`collapseExample${questionIndex}`}
                                          >
                                            <div className="d-flex align-items-center justify-content-between">
                                              <Grid
                                                item
                                                className="pb-0"
                                                xs={6}
                                              >
                                                <div className="text-center">
                                                  <div
                                                    className={`${styles.PreviewContainer} mb-3 d-flex flex-column align-items-center`}
                                                  >
                                                    <MaterialPreview
                                                      type={1}
                                                      isPublic={false}
                                                      src={
                                                        question
                                                          .image_url
                                                          ?.url ||
                                                        question.image_url
                                                      }
                                                      hasClear={true}
                                                      onClear={() =>
                                                        setFieldValue(
                                                          `details.questions[${questionIndex}].image_url`,
                                                          ""
                                                        )
                                                      }
                                                    />
                                                    <Upload
                                                      ref={
                                                        uploadQuestionRef
                                                      }
                                                      onChange={(e) =>
                                                        handleUploadSingleImage(
                                                          e,
                                                          questionIndex,
                                                          "question"
                                                        )
                                                      }
                                                      label={upload}
                                                      name={`details.questions[${questionIndex}].image_url`}
                                                      accept="image/*"
                                                      isImage={true}
                                                      setFieldValue={
                                                        setFieldValue
                                                      }
                                                      isRequired={
                                                        mode ===
                                                        "View"
                                                          ? false
                                                          : true
                                                      }
                                                      isMultiple={
                                                        false
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </Grid>
                                            </div>
                                          </div>
                                          <Input
                                            style={{ width: "100%" }}
                                            name={`details.questions[${questionIndex}].points`}
                                            label={questionPoints}
                                            isRequired={
                                              mode === "View"
                                                ? false
                                                : true
                                            }
                                            type="number"
                                            isNumber={true}
                                            step="0.1"
                                          />

                                          {mode === "View" ? (
                                            <AnswerDisplay
                                              values={values}
                                              questionIndex={
                                                questionIndex
                                              }
                                              question={question}
                                            />
                                          ) : (
                                            <AnswerAddOrEdit
                                              question={question}
                                              questionIndex={
                                                questionIndex
                                              }
                                              setFieldValue={
                                                setFieldValue
                                              }
                                              mode={mode}
                                              values={values}
                                              isDicom={isDicom}
                                              formRef={formRef}
                                            />
                                          )}

                                          <div className={`my-2`}>
                                            <Input
                                              name={`details.questions[${questionIndex}].justification`}
                                              label={explanation}
                                              isRequired={false}
                                            />
                                            {DoesQuestionHasAJustificationPhoto(
                                              values,
                                              questionIndex
                                            ) && (
                                              <div
                                                style={{
                                                  gap: "5px"
                                                }}
                                                className={`${styles.PreviewContainer} mb-3 d-flex flex-column align-items-end w-50 gap-3`}
                                              >
                                                <MaterialPreview
                                                  type={1}
                                                  isPublic={false}
                                                  src={
                                                    question
                                                      ?.justification_image_url
                                                      ?.url ||
                                                    question?.justification_image_url
                                                  }
                                                  hasClear={true}
                                                  onClear={() =>
                                                    setFieldValue(
                                                      `details.questions[${questionIndex}].justification_image_url`,
                                                      ""
                                                    )
                                                  }
                                                />
                                                {mode !== "View" && (
                                                  <Upload
                                                    ref={
                                                      uploadJustificationRef
                                                    }
                                                    onChange={(e) =>
                                                      handleUploadSingleImage(
                                                        e,
                                                        questionIndex,
                                                        "justification"
                                                      )
                                                    }
                                                    label={upload}
                                                    name={`details.questions[${questionIndex}].justification_image_url`}
                                                    accept="image/*"
                                                    isImage={true}
                                                    setFieldValue={
                                                      setFieldValue
                                                    }
                                                    isRequired={false}
                                                    isMultiple={
                                                      isDicom
                                                        ? true
                                                        : false
                                                    }
                                                  />
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </Paper>
                                        {mode !== "View" && (
                                          <div
                                            className="d-flex flex-row mb-4  align-items-center mx-5"
                                            key={JSON.stringify(
                                              questionIndex
                                            )}
                                          >
                                            {values.details.questions
                                              .length > 1 &&
                                              !question?._destroy &&
                                              values.details.questions.filter(
                                                (x) => !x._destroy
                                              ).length !== 1 && (
                                                <div className="mx-2 mb-3">
                                                  <RemoveIcon
                                                    onClick={RemoveQuestion(
                                                      question,
                                                      remove,
                                                      questionIndex,
                                                      replace
                                                      // mode
                                                      // setDestroy
                                                    )}
                                                    className="cursor-pointer"
                                                    disabled={
                                                      values.details.questions.filter(
                                                        (x) =>
                                                          !x._destroy
                                                      ).length === 1
                                                    }
                                                  />
                                                </div>
                                              )}
                                            {AddRemoveNewQuestion(
                                              push
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    )
                                  );
                                }
                              );
                        }}
                      </FieldArray>
                    </div>
                  </Grid>
                  <Grid item xs={6} className="pb-0"></Grid>
                </Grid>
              </fieldset>
              {mode !== "View" && (
                <div className="d-block mt-3 ">
                  <Button
                    text={submit}
                    className="primary-lg"
                    type="submit"
                    data-toggle="tooltip"
                    data-placement="top"
                    // disabled={params.mode === "View" ? true : false}
                  />
                </div>
              )}
            </Form>
          );
        }}
      </Formik>
    </>
  );
}

export default FinalTestFormAEV;
